module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment06_sp-1076f71082fe3d874215214f4722dee0.png";